<template>
    <button :class="[`button flex btn-${color}`, $css(styles.button, $attrs.styles)]" :disabled="disabled">
		<span class="icon" v-if="icon">
			<svg viewBox="0 0 24 20" height="12" width="14">
				<path :d="icon"></path>
			</svg>
		</span>
		<span class="text">{{text}}</span>
	</button>
</template>

<script>
	import consts from "@/common/consts";
	function styles(){
		return this.$style({button:{}});
	}

	export default {
		name: "Button",

		props: {
			text: String,
			icon: String,
			color: {
				default: consts.BTN_COLORS.ORANGE,
				type: String,
			},
			disabled: {
				default: false,
				type: Boolean,
			}
		},

		computed: {
			styles
		}
	}
</script>

<style scoped lang="scss">
	@import "../../../assets/scss/_variables.scss";

.button {
	display: inline-block;
	vertical-align: top;
	font-size: 14px;
	line-height: 20px;
	color: $white;
	border-radius: 4px;
	padding: 10px 15px;
	font-weight: 500;
	letter-spacing: .07px;
	transition: background .4s ease;
	cursor: pointer;

	&.btn-orange {
		background: $orange;

		&:hover {
			background: #a53a00;
		}
	}

	&.btn-blue {
		background: $azure;

		&:hover {
			background: #0054b4;
		}
	}

	.icon {
		margin-right: 2px;

		svg path {
			fill: $white
		}
	}

	&:disabled{
		background: $gray;
		color: $shuttle-gray;
		cursor: default;

		&:hover {
			background: $gray;
		}

		svg path {
			fill: $shuttle-gray
		}
	}
}


</style>
